export interface SignalRMessage {
  timestamp: Date;
  event: string;
  data: any;
}

export const SIGNALR_MESSAGES = {
  // Dispatcher Journal App
  WorkItem: {
    API: {
      Create: 'API-Receive-WorkItem-Create',
      Update: 'API-Receive-WorkItem-Update',
      Delete: 'API-Receive-WorkItem-Delete',
      Restore: 'API-Receive-WorkItem-Restore',
      Batch: 'API-Receive-WorkItem-Batch',
    },
    RTP: {
      Create: 'RTP-Receive-WorkItem-Create',
      Update: 'RTP-Receive-WorkItem-Update',
      ScheduleImported: 'RTP-Schedule-Imported',
      ScheduleImportedAll: 'RTP-Schedule-Imported-All',
    },
  },

  // Health Check App
  HealthCheck: {
    RTP: {
      SnapshotCreate: 'RTP-HealthCheck-Snapshot-Create',
    },
  },

  // Connection Status Messages
  Connection: {
    Established: 'connectionEstablished',
    Reconnecting: 'connectionReconnecting',
    Reconnected: 'connectionReconnected',
    Closed: 'connectionClosed',
    Error: 'connectionError',
    NotEstablished: 'connectionNotEstablished',
    Stopped: 'connectionStopped',
    StopError: 'stopConnectionError',
  },

  // Method Messages
  Method: {
    Result: 'methodResult',
    Error: 'methodError',
  },

  // Reconnection Messages
  Reconnection: {
    Failed: 'reconnectionFailed',
  },
} as const;

// Type for all message names
export type SignalRMessageName =
  | (typeof SIGNALR_MESSAGES.WorkItem.API)[keyof typeof SIGNALR_MESSAGES.WorkItem.API]
  | (typeof SIGNALR_MESSAGES.WorkItem.RTP)[keyof typeof SIGNALR_MESSAGES.WorkItem.RTP]
  | (typeof SIGNALR_MESSAGES.HealthCheck.RTP)[keyof typeof SIGNALR_MESSAGES.HealthCheck.RTP]
  | (typeof SIGNALR_MESSAGES.Connection)[keyof typeof SIGNALR_MESSAGES.Connection]
  | (typeof SIGNALR_MESSAGES.Method)[keyof typeof SIGNALR_MESSAGES.Method]
  | (typeof SIGNALR_MESSAGES.Reconnection)[keyof typeof SIGNALR_MESSAGES.Reconnection];
